"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processFormModel = processFormModel;
exports.compileStaticEnums = compileStaticEnums;
const pi_syntax_tools_1 = require("@icg360/pi-syntax-tools");
const immer_1 = require("immer");
const meta_state_1 = require("../shared/meta-state");
const to_enums_1 = require("../shared/to-enums");
const parse_syntax_nodes_1 = require("./parse-syntax-nodes");
const walker_1 = require("./walker");
function processFormModel(model, 
// This should be true if the FormModel will be used by the model-engine
deleteProcessedEnumsFn = true, formMetaState) {
    let returnModel = model;
    if (!model.process.syntax) {
        returnModel = (0, parse_syntax_nodes_1.parseModelSyntaxNodes)(returnModel);
    }
    if (!model.process.enums) {
        returnModel = compileStaticEnums(returnModel, deleteProcessedEnumsFn, formMetaState);
    }
    return returnModel;
}
function compileStaticEnums(model, 
// This should be true if the FormModel will be used by the model-engine
deleteProcessedEnumsFn = true, formMetaState) {
    let metaState = formMetaState;
    if (!metaState) {
        metaState = (0, meta_state_1.convertToFormMetaState)(model);
    }
    const walker = new walker_1.FormModelWalker();
    return (0, immer_1.produce)({
        type: "model-root",
        key: model.key,
        name: model.name,
        terms: model.terms,
        iterables: model.iterables,
        meta: model.meta,
        compatibility: model.compatibility,
        process: {
            syntax: true,
            enums: true,
        },
    }, draft => {
        draft.process.enums = true;
        if (draft.compatibility) {
            draft.compatibility.dynamicEnums = deleteProcessedEnumsFn;
        }
        for (const node of walker.start(draft, "term")) {
            if (node.type === "term" && node.enumsFn?.type === "syntax-tree") {
                const context = (0, pi_syntax_tools_1.getContext)({
                    ...metaState,
                    this: walker.currentIterable
                        ? {
                            term: metaState.terms[node.name],
                            iterable: metaState.iterables[walker.currentIterable.name],
                        }
                        : { term: metaState.terms[node.name] },
                });
                if (noDynamicPaths(node.enumsFn, context)) {
                    const enumOutput = (0, pi_syntax_tools_1.execSyntax)(node.enumsFn.tree, context);
                    if (!node.enums) {
                        node.enums = [];
                    }
                    if (deleteProcessedEnumsFn) {
                        delete node.enumsFn;
                    }
                    const enums = (0, to_enums_1.toEnums)(enumOutput);
                    node.enums.push(...enums);
                }
            }
        }
    });
}
function noDynamicPaths(syntax, context) {
    for (const path of (0, pi_syntax_tools_1.walkSyntax)(syntax.tree)) {
        if (path.type !== "path") {
            continue;
        }
        const output = (0, pi_syntax_tools_1.execSyntax)(path, context);
        if (output === undefined) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=process-form-model.js.map